var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4797 20.0001H1.97932C0.887744 20.0001 0 19.1123 0 18.0208V2.52034C0 1.42876 0.887744 0.541016 1.97932 0.541016H11.006C11.4115 0.541016 11.74 0.869603 11.74 1.27505C11.74 1.68049 11.4115 2.00908 11.006 2.00908H1.97932C1.69752 2.00908 1.46806 2.23853 1.46806 2.52034V18.0208C1.46806 18.3026 1.69752 18.532 1.97932 18.532H17.4797C17.7616 18.532 17.991 18.3026 17.991 18.0208V9.70583C17.991 9.30038 18.3196 8.9718 18.725 8.9718C19.1305 8.9718 19.4591 9.30038 19.4591 9.70583V18.0208C19.4591 19.1123 18.5713 20.0001 17.4797 20.0001Z",
    fill: "#868E96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42533 12.1441L4.22125 15.6126C4.11655 15.9123 4.40281 16.2008 4.70355 16.0994L8.18324 14.9276L17.7524 5.44759L14.9945 2.66406L5.42533 12.1441Z",
    fill: "#868E96"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2456 2.97804C20.5073 2.71852 20.5095 2.29637 20.25 2.03461L18.4311 0.19786C18.1715 -0.0638966 17.7494 -0.0661243 17.4888 0.19229L16.043 1.6236L18.8009 4.40712L20.2456 2.97582V2.97804Z",
    fill: "#868E96"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPencil);
export default __webpack_public_path__ + "static/media/icon_pencil.ebd3116f.svg";
export { ForwardRef as ReactComponent };